import React, { useState, useEffect } from 'react';

import Button from 'react-bootstrap/Button';
import Modal from "react-bootstrap/Modal";

const MatchEndModal = (props) => {

    const { show, onHide } = props;
    
    return <Modal
        show={show}
        onHide={onHide}
        backdrop="static"
        centered
    >
        <Modal.Header closeButton>
            <Modal.Title>
                <h3>
                    Match Ended
                </h3>
            </Modal.Title>
        </Modal.Header>
        <Modal.Body>

        </Modal.Body>
        <Modal.Footer>
            <Button variant="primary" onClick={onHide}>Close</Button>
        </Modal.Footer>
    </Modal>;
}

export default MatchEndModal;